import { render, staticRenderFns } from "./CartaoInformacoesTransplante.vue?vue&type=template&id=6de3c820&scoped=true"
import script from "./CartaoInformacoesTransplante.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesTransplante.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoesTransplante.vue?vue&type=style&index=0&id=6de3c820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de3c820",
  null
  
)

export default component.exports